import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DNACenterLogo from "../../../assets/images/logo-dna-center.png";
import BackgroundContainer from "../../../components/BackgroundContainer/BackgroundContainer";
import { Button } from "@mui/material";
import "./styles.css";

export default function ConfirmacaoEnvioRel() {
  const [protocolo, setProtocolo] = useState("");
  const location = useLocation();

  const copiarCodigo = () => {
    navigator.clipboard.writeText(protocolo);
  };

  useEffect(() => {
    setProtocolo(location?.state?.protocolo);
  }, [location]);

  return (
    <BackgroundContainer>
      <main style={{ width: "100vw", height: "100vh" }}>
        <div className="confirmation-card">
          <div>
            <h1 style={{ marginBottom: "1rem" }}>Formulário enviado!</h1>
            <p>Agradecemos sua confiança.</p>
            <p>
              Guarde o protocolo para consultar sua denúncia futuramente:
              <br />
              <strong>{protocolo}</strong>
            </p>
            <Button onClick={copiarCodigo} variant="outlined" color="primary">
              Copiar protocolo
            </Button>
          </div>
          <img
            src={DNACenterLogo}
            alt="Logo do DNA Center"
            style={{ width: "240px", height: "140px", alignSelf: "center" }}
          />
        </div>
        <Link to={"/canaldaetica"} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary">
            Voltar
          </Button>
        </Link>
      </main>
    </BackgroundContainer>
  );
}
